export default __webpack_public_path__ + "static/media/shapes-plankStone.6416bd05.png";